module.exports = __webpack_public_path__ + "static/media/inline-hockey.cea4ffae.svg";